export const AFTER_DATE = new Date('2025-06-02').getTime();

export function isPostWedding() {
    // return true;
    return new Date().getTime() >= AFTER_DATE;
}

export function isToday() {
    const from = new Date('2025-05-31 7:00').getTime();
    const to = AFTER_DATE

    const now = new Date().getTime();

    // return true;
    return now >= from && now <= to;
}
